import { render } from "./FormLocalization.vue?vue&type=template&id=3ba09ea6"
import script from "./FormLocalization.vue?vue&type=script&lang=js"
export * from "./FormLocalization.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormLocalization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ba09ea6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ba09ea6', __exports__)) {
    console.log('reload')
    api.reload('3ba09ea6', __exports__)
  }
  
  module.hot.accept("./FormLocalization.vue?vue&type=template&id=3ba09ea6", () => {
    console.log('re-render')
    api.rerender('3ba09ea6', render)
  })

}


export default __exports__